/* Registers public/service-worker.js. Only in production builds — in dev,
 * a stale cached bundle fighting with the dev server's live-reload is far
 * more confusing than useful. */
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

export function register(onUpdateReady) {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    if (isLocalhost) return; // still skip on a production build served from localhost during local testing
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === "installed" && navigator.serviceWorker.controller) {
              onUpdateReady?.(registration);
            }
          };
        };
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready.then((registration) => registration.unregister()).catch(() => {});
}
